// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  ErrorResponse,
  ErrorDetail,
  ErrorAdditionalInfo,
  SearchDocumentsResult,
  FacetResult,
  QueryAnswerResult,
  SearchRequest,
  QueryType,
  ScoringStatistics,
  QueryDebugMode,
  SearchMode,
  SemanticErrorMode,
  QueryAnswerType,
  QueryCaptionType,
  VectorQuery,
  VectorQueryUnion,
  VectorQueryKind,
  VectorizedQuery,
  VectorizableTextQuery,
  VectorizableImageUrlQuery,
  VectorizableImageBinaryQuery,
  VectorFilterMode,
  SearchResult,
  QueryCaptionResult,
  DocumentDebugInfo,
  VectorsDebugInfo,
  QueryResultDocumentSubscores,
  TextResult,
  SingleVectorFieldResult,
  SemanticErrorReason,
  SemanticSearchResultsType,
  LookupDocument,
  SuggestDocumentsResult,
  SuggestResult,
  IndexDocumentsBatch,
  IndexAction,
  IndexActionType,
  IndexDocumentsResult,
  IndexingResult,
  AutocompleteResult,
  AutocompleteItem,
  AutocompleteMode,
} from "./models.js";
export {
  KnownQueryType,
  KnownQueryDebugMode,
  KnownSemanticErrorMode,
  KnownQueryAnswerType,
  KnownQueryCaptionType,
  KnownVectorQueryKind,
  KnownVectorFilterMode,
  KnownSemanticErrorReason,
  KnownSemanticSearchResultsType,
} from "./models.js";
